module.exports = __webpack_public_path__ + "media/images/products/market-desktop-sidephoto-c3874014d2e8bed0c9a3f263adc0e981.png";